
import { ref, reactive, defineComponent } from 'vue'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import TextLink from '@/components/elements/TextLink.vue'
import CbtTermCard from '@/components/block/CbtTermCard.vue'
import { axiosSetting } from '@/utils/axiosSetting'

export default defineComponent({
  name: 'Cbt',
  components: {
    Button,
    TextLink,
    CbtTermCard
  },
  setup() {
    const results: any[] = reactive([])
    const activeAllResult = ref(false)
    const store = useStore()
    const ajax = axiosSetting('app', 'action')

    const getData = () => {
      const titles = [
        {
          title: '基本事項 / 医学一般(30問)'
        },
        {
          title: '人体各器官の正常構造と機能、病態、診断、治療(30問)'
        },
        {
          title: '全身に及ぶ生理的変化、病態、診断、治療(30問)'
        },
        {
          title: '診療の基本 / 社会と医学・医療(30問)'
        },
        {
          title: '4連問特集(20問)'
        }
      ]

      const params = {
        users_id: store.state.userInfo.zip,
        year: '2022'
      }

      ajax.post('/api/v1/cbt_previous_results', params).then((res: any) => {
        res.data.forEach((item: any, index: number) => {
          const merged = { ...item, ...titles[index] }
          results.push(merged)
        })
        activeAllResult.value = res.data.every(
          (item: any) => item.last_test_day !== ''
        )
      })
    }
    getData()

    return {
      results,
      activeAllResult
    }
  }
})
